import request from '@/apis/request'
const resource = 'auth/anonymous'
const resource2 = 'auth/users'

export default {
  requestOTPRegister: (data) => {
    return request.post(`${resource}/password`,data)
  },

  register: (data) => {
    return request.post(`${resource}/register`,data)
  },

  demoRegister: (data) => {
    return request.post(`${resource}/demo-register`,data)
  },

  registerById: (id, data) => {
    return request.post(`${resource}/register/${id}`,data)
  },

  login: (data) => { 
    return request.post(`${resource2}/login`,data)
  },

  logout: () => { 
    return request.get(`${resource2}/logout`)
  },

  requestOTPResetPassword: (data) => { 
    return request.post(`${resource2}/reset-password`,data)
  },

  requestOTPResetPasswordDefault: (data) => { 
    return request.post(`${resource2}/reset-password-default`, data)
  },

  verifyOTPResetPassword: (data) => { 
    return request.put(`${resource2}/reset-password`,data)
  },
}